(function () {
  'use strict';
  const policy = typeof module !== 'undefined' ? require('./product-delivery-policy') : window.InspireDeliveryPolicy;
  if (!policy) return;
  const { addBusinessDays, preparationDays, timeline, format } = policy;
  if (typeof module !== 'undefined') module.exports = { addBusinessDays, preparationDays, timeline };
  if (typeof document === 'undefined') return;
  const script = document.currentScript;
  const zone = script?.dataset.shopTimeZone || 'America/Los_Angeles';
  function update() {
    const root = document.querySelector('[data-catalog-layout]'); if (!root) return;
    const dates = policy.current(zone);
    const set = (selector, text, tooltip) => {
      const el = root.querySelector('[data-bold-delivery] ' + selector + ' .date__sub-content > span'); if (!el) return;
      const node = [...el.childNodes].find(n => n.nodeType === 3);
      if (node && node.textContent !== text) node.textContent = text;
      const p = el.querySelector('p'); if (p && p.textContent !== tooltip) p.textContent = tooltip;
    };
    const days = preparationDays(dates.ordered);
    set('.ordered-content-box__step-box', format(dates.ordered), 'Allow ' + days + ' business days after placing your order for shipment preparation.');
    set('.order-ready-content-box__step-box', format(dates.ready), 'Estimated ready to ship ' + days + ' business days after your order is placed.');
    set('.order-delivered-content-box__step-box', format(dates.earliest) + ' – ' + format(dates.latest), 'Estimated delivery 1–5 business days after your order is ready; timing depends on the shipping method chosen at checkout.');
    for (const input of root.querySelectorAll('input[name="properties[Delivery Estimated between (depending on your selected shipping speed)]"]')) input.value = dates.value;
    root.dataset.draftOrderReady = dates.ready; root.dataset.draftDeliveryEarliest = dates.earliest; root.dataset.draftDeliveryLatest = dates.latest;
  }
  let queued = false;
  const schedule = () => { if (queued) return; queued = true; requestAnimationFrame(() => { queued = false; update(); }); };
  const init = () => { update(); const root = document.querySelector('[data-catalog-layout]'); if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('product-info:loaded', schedule);
  setInterval(schedule, 60000);
})();
